export const getAppVersion = () => `${__HYDRA__APP__VERSION__}+${__COMMIT_HASH__}`;
